import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// @ts-ignore -- ReadonlyTransaction is a local declaration and will cause a TS2305 error in CCFE typecheck
import { pluginFactory } from '@atlaskit/editor-common/utils';
import { pluginKey } from './plugin-key';
import reducer from './reducer';
function mapping(tr, pluginState) {
  if (pluginState && pluginState.resizeHandlePos !== null) {
    return _objectSpread(_objectSpread({}, pluginState), {}, {
      resizeHandlePos: tr.mapping.map(pluginState.resizeHandlePos)
    });
  }
  return pluginState;
}
var factory = pluginFactory(pluginKey, reducer, {
  mapping: mapping
});
export var createCommand = factory.createCommand;
export var createPluginState = factory.createPluginState;
export var getPluginState = factory.getPluginState;